// extracted by mini-css-extract-plugin
export var avatar = "_nf-3";
export var avatarContainer = "_nf-2";
export var avatarSpacer = "_nf-5";
export var avatarSpacerContainer = "_nf-4";
export var avatarStackContainer = "_nf-1";
export var bubble = "_nf-0";
export var remainderBubble = "_nf-6";